import { Component, Input, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'swisscom-sign-control-error-label',
  templateUrl: './control-error-label.html',
  providers: [TranslatePipe],
  standalone: false,
})
export class ControlErrorLabelComponent {
  private translate = inject(TranslatePipe);

  @Input() control: AbstractControl | null = null;

  public getErrorMessage(): string {
    if (!this.control) return '';

    if (this.control.errors) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let iterator: any;
      for (iterator in this.control.errors) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errObject: any = this.control.errors[iterator];

        // If the error object contains a field named 'msgData' the content of that field will get added to the error message
        let msgData = '';
        if (errObject['msgData']) {
          msgData = ' : ' + errObject['msgData'];
        }

        // To be able to add the 'msgData' content to the error message the translation pipe had to be moved moved from the template to the code.
        if (iterator.includes('.')) {
          return this.translate.transform(iterator) + msgData;
        }
        return this.translate.transform('App.Validation.' + iterator + '.Error') + msgData;
      }
    }

    return '';
  }
}
